<template>
    <div>
        <div class="elasticacheResource-title">
            <div>ElastiCache</div>
            <div>
                <Button type="primary" :loading="modal_loading" @click="exportList" v-hasPermission="['resourceConfigurationManagement:aws:reservedInstanceResource:elasticCache:export']">{{ $t('common.export') }}</Button>
            </div>
        </div>
        <div class="elasticacheResource-top">
            <elasticache-resource-search ref="reservedCacheNodeSearch"></elasticache-resource-search>
        </div>
        <table-elasticache-resource></table-elasticache-resource>
    </div>
</template>

<script>
    import ElasticacheResourceSearch from '../elasticache/ElasticacheResourceSearch'
    import TableElasticacheResource from '../elasticache/TableElasticacheResource'

    export default {
        name: 'ElasticacheResource',
        components: {
            ElasticacheResourceSearch,
            TableElasticacheResource
        },
        data () {
            return {
                modal_loading: false,
                accountIds: [],
                regions: [],
                engine: '',
                awsId: '',
                state: '',
                expiration: ''
            }
        },
        methods: {
            //导出
            exportList: function () {
                // 获取子组件数据
                this.awsId = this.$refs.reservedCacheNodeSearch.awsId;
                this.accountIds = this.$refs.reservedCacheNodeSearch.accountIds;
                this.regions = this.$refs.reservedCacheNodeSearch.regions;
                this.engine = this.$refs.reservedCacheNodeSearch.engine;
                this.state = this.$refs.reservedCacheNodeSearch.state;
                this.expiration = this.$refs.reservedCacheNodeSearch.expiration;

                if (this.accountIds == "" || this.accountIds == null) {
                    this.$Message.warning("请选择账号", 5)
                    return;
                }
                if (this.regions == "" || this.regions == null) {
                    this.$Message.warning("请选择区域", 5)
                    return;
                }

                this.modal_loading = true
                this.$Message.loading({
                  duration: 0,
                  content: '正在导出，请稍等...'
                })
                // 下载Excel 文件
                this.$api.reservedInstance.exportReservedCacheNodes({
                   "initAccountType": 2,
                    "accountId": this.awsId,
                    "accountIds": this.accountIds,
                    "regions": this.regions,
                    "engine": this.engine,
                    "expiration": this.expiration,
                    "state": this.state
                })
                .then(res => {
                    let fileName = 'ElastiCache预留实例.xls'
                    let blob = new Blob([res.data], {type: 'application/x-xls'})
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                    this.modal_loading = false;
                    this.$Message.destroy();
                    this.$Message.success('导出成功');
                })
            }
        }

    }
</script>

<style scoped>
    .elasticacheResource-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        overflow: hidden;
        font-weight: 600;
    }
    .elasticacheResource-title>div:nth-child(1)
    {
            float:left;
    }
    .elasticacheResource-title>div:nth-child(2)
    {
            float:right;
            margin-top: -6px;
    }
    .elasticacheResource-top
    {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/elasticache/ElasticacheResource.vue